import {useQuery} from '@tanstack/react-query';

import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

const KLARNA_MESSAGING_QUERY_KEY = ['klarnaMessaging', 'klarnaBadge'];

type UseKlarnaMessagingPropsType = {
    purchaseAmount: number;
    locale?: string;
    placementKey?: string;
    enabled?: boolean;
};

/**
 * React query hook for Klarna messaging URL
 */
export const useKlarnaMessaging = ({
    enabled = true,
    locale = 'en-US',
    placementKey = 'credit-promotion-badge',
    purchaseAmount,
}: UseKlarnaMessagingPropsType) => {
    const {data: klarnaUrl} = useQuery({
        enabled: enabled && purchaseAmount > 0,
        queryFn: async () => {
            try {
                const {data} = await apiConfig.instanceGusaBackend({
                    baseURL: apiConfig.API_URL,
                    method: 'GET',
                    params: {
                        locale,
                        placementKey,
                        purchaseAmount,
                    },
                    url: '/payment/klarna/messaging',
                });

                return data;
            } catch (error) {
                logWithSentry(error, 'Failed to fetch Klarna messaging URL');
                return '';
            }
        },
        queryKey: [...KLARNA_MESSAGING_QUERY_KEY, purchaseAmount],
        refetchOnWindowFocus: false,
    });

    return {klarnaUrl};
};
